export enum Quadrant {
  A,
  B,
  C,
  D,
  F,
  XC,
  XA,
  E,
  XD,
}
